module.exports = __webpack_public_path__ + "media/v2/components/HomePage/shared/PrizeSlider/img/new/danny_imagem-8f09bdc8c687ec91252de1ded6a1d1d7.png";